<template>
  <div class="addGood">
    <!-- 添加买家 -->
    <md-popup v-model="show" :mask-closable="false">
      <md-popup-title-bar title="新增货品" :only-close="true" @cancel="cancelPop()"></md-popup-title-bar>
      <div class="pop_content">
          <md-field>
            <md-input-item title="名称" clearable type="text" v-model="subData.name" placeholder="请输入货品名称"></md-input-item>
            <div class="filed_flex">
              <md-field-item solid title="分类" style="width:100%" placeholder="请选择分类">
                <el-select v-model="subData.cate_id" placeholder="请选择分类" :popper-append-to-body="false">
                  <el-option v-for="item in cateList"
                    :key="item.cate_id"
                    :label="item.cate_name"
                    :value="item.cate_id">
                  </el-option>
                </el-select>
              </md-field-item>
            </div>
            <div class="filed_flex">
              <md-field-item solid title="类型" style="width:48%">
                <md-radio-group v-model="subData.type">
                  <md-radio-box name="1">自营</md-radio-box>
                  <md-radio-box name="2">代卖</md-radio-box>
                </md-radio-group>
              </md-field-item>
              <md-field-item solid title="库存" style="width:48%">
                <md-radio-group v-model="subData.is_strong">
                  <md-radio-box name="1">弱库存</md-radio-box>
                  <md-radio-box name="2">强库存</md-radio-box>
                </md-radio-group>
              </md-field-item>
            </div>
            <md-field-item solid title="包装">
              <md-radio-group v-model="subData.bale">
                <md-radio-box name="1">定装</md-radio-box>
                <md-radio-box name="2">非定装</md-radio-box>
                <md-radio-box name="3">散装</md-radio-box>
              </md-radio-group>
            </md-field-item>
            <md-field-item solid title="单位" v-if="subData.bale == 1 || subData.bale == 2" >
              <md-radio-group v-model="subData.num_unit">
                <md-radio-box v-for="(item,index) in unit_list" :key="index" :name="item.value + ''">{{item.name}}</md-radio-box>
              </md-radio-group>
            </md-field-item>
            <div class="filed_flex">
              <md-input-item v-if="subData.bale == 1" title="规格" clearable type="number" v-model="subData.bale_num" placeholder="请输入规格" style="width:48%">
                <template slot="right">
                  公斤/{{unit_list[subData.num_unit - 1].name}}
                </template>
              </md-input-item>
              <md-input-item v-if="subData.bale == 1  || subData.bale == 2" title="数量" clearable type="number" v-model="subData.num" placeholder="请输入数量" style="width:48%">
                <template slot="right">
                  {{unit_list[subData.num_unit - 1].name}}
                </template>
              </md-input-item>
              <md-input-item v-if="subData.bale == 3 || subData.bale == 2" title="重量" clearable type="number" v-model="subData.weight" placeholder="请输入重量" style="width:48%">
                <template slot="right">
                  公斤
                </template>
              </md-input-item>
              <!-- <md-input-item title="单价" clearable type="number" v-model="subData.price" placeholder="请输入单价">
                <template slot="right">
                  元/
                  <span v-if="subData.bale == 1">{{unit_list[subData.num_unit - 1].name}}</span>
                  <span v-if="subData.bale != 1">公斤</span>
                </template>
              </md-input-item> -->
              <md-input-item title="货款" clearable type="number" v-model="subData.amount" placeholder="请输入货款" style="width:48%">
                <template slot="right">
                  元
                </template>
              </md-input-item>
              <md-input-item title="售价" clearable type="number" v-model="subData.proposed_price" placeholder="请输入售价"  style="width:48%">
                <template slot="right">
                  元/
                  <span v-if="subData.bale == 1">{{unit_list[subData.num_unit - 1].name}}</span>
                  <span v-if="subData.bale != 1">公斤</span>
                </template>
              </md-input-item>
            </div>
          </md-field>
          <div class="pop_btns">
            <md-button type="warning" plain size="small" inline @click="cancelPop()">取消</md-button>
            <md-button type="primary" size="small" inline @click="submitData(1)">保存</md-button>
            <md-button type="primary" size="small" inline @click="submitData(2)">保存并继续</md-button>
          </div>
      </div>
    </md-popup>
  </div>
</template>

<script>
import { goods_create,goodsCate_getList } from "@/api/work/stock";
import { isNumFloat,isPosFloat } from "@/utils/validate";
export default {
  name: 'addGood',
  data(){
    return {
      show:false,
      loading:true,
      isCateShow:false,
      cateList:[],
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" }
      ],
      batch_id:'',
      subData:{
        batch_id:'',
        name:'',
        type:'1',
        bale:'1',
        num_unit:'1',
        bale_num:'',
        num:'',
        weight:'',
        price:'',
        amount:'',
        cate_id:'1',
        proposed_price:'',
        is_strong:'1',  // 1弱库存，2强库存
        surcharge:JSON.stringify([]), // 附加费
      },
    }
  },
  created(){
    
  },
  mounted(){




  },
  methods:{
    // 显示弹窗
    showPop(batch_id){
      this.getCateList()
      this.subData.batch_id = batch_id
      this.batch_id = batch_id
      this.show = true
    },
    // 取消弹窗
    cancelPop(){
      this.show = false
      this.resetData()
      this.$emit("cancel")
    },
    // 取消弹窗
    finishPop(){
      this.show = false
      this.resetData()
      this.$emit("finish")
    },
    // 重置数据
    resetData(){
      this.subData ={
        batch_id:'',
        name:'',
        bale:'1',
        type:'1',
        num_unit:'1',
        bale_num:'',
        num:'',
        weight:'',
        price:'',
        amount:'',
        cate_id:'1',
        proposed_price:'',
        is_strong:'1',  // 1弱库存，2强库存
        surcharge:JSON.stringify([]), // 附加费
      }
      this.cateList = []
    },

    // 获取所有分类
    getCateList(){
      goodsCate_getList().then(res=>{
        if(res.code == 200){
          this.cateList = res.data.list
          this.cateList.unshift({cate_id:'1',cate_name:'未分类'})
        }
      })
    },
    // 提交数据
    submitData(type){
      if(!this.loading){ return false }
      if(!this.subData.name){this.$toast.info("请输入货品名称！"); return false }
      if(!this.subData.cate_id){this.$toast.info("请选择货品分类！"); return false }
      if(this.subData.bale == 1 &&( !isPosFloat(this.subData.bale_num) || this.subData.bale_num == 0) ){this.$toast.info("请输入货品规格！"); return false }
      if((this.subData.bale == 1 || this.subData.bale == 2) && (!isPosFloat(this.subData.num) || this.subData.num == 0) ){this.$toast.info("请输入货品数量！"); return false }
      if((this.subData.bale == 2 || this.subData.bale == 3) && (!isPosFloat(this.subData.weight) || this.subData.weight == 0)){this.$toast.info("请输入货品重量！"); return false }
      if( (!isPosFloat(this.subData.amount) || this.subData.amount == 0)){this.$toast.info("请输入货款金额！"); return false }
      if(String(this.subData.proposed_price).length>0 && (!isPosFloat(this.subData.proposed_price))){this.$toast.info("请输入正确的销售单价！"); return false }
      this.subData.batch_id = this.batch_id
      var subData = JSON.parse(JSON.stringify(this.subData))
      if(subData.bale == 1){
        subData.price = (Math.round(subData.amount * 100 / subData.num)/100).toFixed(2)
      }else{
        subData.price = (Math.round(subData.amount * 100 / subData.weight)/100).toFixed(2)
      }

      this.loading = false
      goods_create(subData).then(res=>{
        this.loading = true
        this.$toast.succeed(res.message)
        if(type == 1){
          this.finishPop()
        }else{
          this.$emit("finish")
          this.resetData()
          this.getCateList()
        }
      }).catch(err=>{
        this.loading = true
      })
    },
  }
}
</script>

<style lang="less" scoped>
.addGood{
  position: relative;
  // 添加买家模块
  .pop_content {
    width: 7rem;
    // margin-top: -0.2rem;
    // height: 6rem;
    background-color: #fff;
    border-radius:0 0 0.08rem 0.08rem;
    overflow: hidden;
    padding:0 0.2rem;
    position: relative;
    border-top: 0.01rem solid #e1e1e1;
    .pop_btns{
      padding: 0.15rem 1rem 0.2rem;
      display: flex;
      align-items: center;
      justify-content: space-around;
    }
    .select{
      width: 100%;
      font-size: 0.24rem;
      color: #404040;
      border: none;
      &:focus,&:active{
        border:none;
      }
    }
  }
}
</style>
<style lang="less">
.addGood{
  .md-radio-group{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-start;
    .md-check-base-box{
      font-size: 0.18rem;
    }
  }
  .md-field-item.is-solid .md-field-item-title{
    width: 0.6rem;
    font-size: 0.2rem;
  }
  .filed_flex{
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .md-field-item-control input::placeholder{
    font-size: 0.2rem;
  }
  .el-select{
    width: 100%;
    .el-input input {
      border:none;
      padding-left: 0;
      vertical-align: middle;
      font-size: 0.2rem;
    }
    .el-input__icon{
      font-size: 0.24rem;
    }
    .el-select-dropdown{
      margin-top: 8px;
      margin-left: -0.01rem;
      font-size: 0.2rem;
      .el-select-dropdown__item{
        font-size: 0.2rem;
        height: 0.4rem;
        line-height: 0.4rem;
        margin: 0.05rem 0;
        color: #666;
        padding: 0 0.1rem;
        &.hover,&.selected{
          color: #31b158;
        }
      }
    }
  }
}
</style>